import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Customer = apiContainer.Customer
//GET--->
// Corrected getCustomer function
export async function getCustomerApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Customer}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createCustomer(request) {
    try {
        return api.create(`${Customer}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateCustomer(request, CustomerId) {
    try {
        return api.update(`${Customer}/${CustomerId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteCustomer(CustomerId) {
    try {
        return api.delete(`${Customer}/${CustomerId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



